import { request } from 'services/configs/axiosConfig';
import { ENDPOINT } from 'services/configs/endpoint.constant';

export const sharepointService = {
  getConnections: async (confirmed: boolean | null = true) => {
    return request({
      url: ENDPOINT.GET_ALL_CONNECTIONS,
      method: 'GET',
      params: { confirmed },
    });
  },
  createConnection: async ({ displayName }: { displayName: string }) => {
    const redirectUrl = `${window.location.origin}${ENDPOINT.REDIRECT_SHAREPOINT}`;
    return request({
      url: ENDPOINT.CREATE_CONNECTION,
      method: 'POST',
      data: {
        display_name: displayName,
        redirect_url: redirectUrl,
      },
    });
  },
  confirmConnection: async (confirmName: string) => {
    return request({
      url: `${ENDPOINT.COMFIRM_CONNECTION}${confirmName}`,
      method: 'PUT',
    });
  },

  deleteConnection: async (id: string) => {
    return request({
      url: `${ENDPOINT.DELETE_CONNECTION}${id}`,
      method: 'DELETE',
      responseType: 'text',
    });
  },
};
